import { clsxMerge } from '../common/utils/classNameUtils';

export type ProgressBarProps = {
  className?: string;
};

export const ProgressBar = ({
  className = '',
  ...props
}: ProgressBarProps): JSX.Element => {
  return (
    <div
      className={clsxMerge(
        "text-brand-breeze-primary-500 w-32 min-h-2 color rounded-lg relative overflow-hidden  bg-gray-100 before:content-[''] before:absolute before:inset-0  before:w-full before:h-full before:bg-current before:rounded-[inherit] before:animate-slide",
        className,
      )}
      role="loader"
      data-testid="loader-progress-bar"
      {...props}
    />
  );
};
